/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Box, VStack, Center } from 'chakra-v3';
import { Text } from '../../components/Text';

const IntendedUse: React.FC = () => {
  const listItems = [
    'Audit LLM readiness for high-stakes deployment',
    'Compare models on grounded, multilingual benchmarks',
    'Identify context-specific risks',
    'Guide safer fine-tuning and domain adaptation',
  ];

  return (
    <Box
      w="100%"
      pt={{ base: 8, md: '60px' }}
      pb={{ base: 8, md: '80px' }}
      px={{ base: 4, md: 6 }}
      bg="#0A313C"
    >
      <VStack
        gap={{ base: 8, md: '46px' }}
        alignItems="center"
        w="100%"
        maxW={{ base: '100%', md: '1200px' }}
        mx="auto"
      >
        {/* Main Heading */}
        <Text
          fontFamily="heading"
          fontSize={{ base: '32px', sm: '36px', md: '40px', lg: '72px' }}
          fontWeight="300"
          lineHeight="normal"
          letterSpacing="-1px"
          color="#f6f6f6"
          w="100%"
          textAlign="center"
          whiteSpace="pre-wrap"
        >
          Intended Use
        </Text>

        {/* Introductory Text */}
        <Text
          fontFamily="body"
          fontSize={{ base: '18px', sm: '20px', md: '24px' }}
          fontWeight="normal"
          lineHeight="1.4"
          letterSpacing="0.12px"
          color="#f6f6f6"
          w="100%"
          textAlign="center"
          whiteSpace="pre-wrap"
        >
          Researchers, policymakers, and model builders can use Samiksha to:
        </Text>

        {/* Numbered List */}
        <Center w="100%" maxW={{ base: '100%', md: '1200px' }}>
          <Box
            as="ol"
            listStyleType="decimal"
            ml="36px"
            fontFamily="heading"
            fontSize={{ base: '16px', sm: '18px', md: '24px', lg: '24px' }}
            fontWeight="normal"
            lineHeight="0"
            color="#f6f6f6"
          >
            {listItems.map((item, index) => (
              <Box as="li" key={index} mb={0}>
                <Text
                  as="span"
                  fontFamily="heading"
                  fontSize={{ base: '16px', sm: '18px', md: '24px', lg: '24px' }}
                  fontWeight="normal"
                  lineHeight={{ base: '24px', md: '40px', lg: '40px' }}
                  color="#f6f6f6"
                >
                  {item}
                </Text>
              </Box>
            ))}
          </Box>
        </Center>
      </VStack>
    </Box>
  );
};

export default IntendedUse;
